package com.zi.support.shared

/**
 * Support user roles: user, admin and superadmin. Super admin is fixed to [SUPER_ADMINS] (matched by username, the
 * same list as SUPER_ADMINS in functions/index.js, which enforces it); only they can delete tickets.
 */
object SupportRoles {
    const val SUPER_ADMIN = "superadmin"
    val SUPER_ADMINS: Set<String> = setOf("devesh", "suleiman")

    fun isSuperAdmin(username: String?): Boolean = username.orEmpty().trim().lowercase() in SUPER_ADMINS

    /** Admin screens are open to admins and super admins. */
    fun isAdmin(role: String?): Boolean = role.orEmpty().lowercase() in setOf("admin", SUPER_ADMIN)

    fun label(role: String?): String = when (role.orEmpty().lowercase()) {
        SUPER_ADMIN -> "Super admin"
        "admin" -> "Admin"
        else -> "User"
    }
}
